const i = "focus-visible:outline-(--color-focus-main-highlight) focus-visible:outline-offset-1 focus-visible:outline focus-visible:ring-3 focus-visible:ring-(--color-focus-main) focus-visible:ring-offset-1 transition-colors";
export {
  i as focusRing
};
